export const validateStoreLogin = (values = {}) => {
  const errors = [];
  const email = String(values.email || '').trim();
  const storeCode = String(values.storeCode || '').trim();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    errors.push('Email is required.');
  }

  if (!storeCode) {
    errors.push('Store code is required.');
  }

  const password = String(values.password || '').trim();
  if (!password) {
    errors.push('Password is required.');
  }

  if (email && !emailPattern.test(email)) {
    errors.push('Enter a valid email address.');
  }

  return errors;
};
